import {
    RunnitNodeFieldDisplaySLIDER,
    RunnitNodeFieldDisplayCFG,
    RunnitNodeFieldDisplaySTEPS,
    RunnitNodeFieldDisplayUPSCALE_FACTOR_SLIDER,
    runnitValidateField,
    RunnitFieldValidationResult,
} from '@run-diffusion/shared';

export type ValidationResult = RunnitFieldValidationResult;

export type SliderDisplay =
    | RunnitNodeFieldDisplaySLIDER
    | RunnitNodeFieldDisplayCFG
    | RunnitNodeFieldDisplaySTEPS
    | RunnitNodeFieldDisplayUPSCALE_FACTOR_SLIDER;

export interface ValidateSliderValueOptions {
    /**
     * Whether to enforce step alignment validation.
     * When false, only range (min/max) validation is performed.
     * When true (default), step alignment is checked (with step defaulting to 1 if missing).
     */
    requireStepAlignment?: boolean;
}

export function validateSliderValue(
    display: SliderDisplay | null | undefined,
    value: unknown,
    options: ValidateSliderValueOptions = {},
): ValidationResult {
    if (!display) return { valid: true };
    const { requireStepAlignment = true } = options;

    if (requireStepAlignment) {
        return runnitValidateField(value, {
            __rfield: true,
            uuid: '',
            fieldDefUuid: '',
            type: 'SLIDER',
            display,
        } as any);
    }

    // Range-only path: run the full validator, then accept step-misalignment as valid.
    const full = runnitValidateField(value, {
        __rfield: true,
        uuid: '',
        fieldDefUuid: '',
        type: 'SLIDER',
        display,
    } as any);
    if (!full.valid && full.reason && full.reason.startsWith("Value doesn't align with step")) {
        return { valid: true };
    }
    return full;
}
